<template>
	<div class="PreviewSwiper_picture_and_video_box" @click.stop="closurePreview()" :class="get_type_name() ? 'swiper_picture_box' : 'swiper_video_box'">
		<div class="closurePreview" @click.stop="closurePreview()"><i class="el-icon-close"></i></div>
		<div @click.stop v-if="fileList && fileList.SlideTotal > 0" class="media-carousel" @mouseenter="stopAutoplay()"  @mouseleave="startAutoplay()">
		
			<!-- :ref="'swiper' + fileList ? fileList.post_id : 1" -->
			<swiper 
				:id="swiper_post_id"
				:ref="swiper_post_id"
				class="swiper swiperBox" 
				:options="swiperOption" 
				@mouseenter="stopAutoplay" 
				@mouseleave="startAutoplay"
				@slideChangeTransitionEnd="change"
			>	
				<!-- 总数和当前数 -->
				<div class="quantityBox" v-if="fileList && fileList.SlideTotal > 1">
					<div class="quantity">{{ fileList.currentSlideIndex ? fileList.currentSlideIndex : 1 }}</div>
					<div class="quantity">/</div>
					<div class="quantity">{{ fileList.SlideTotal }}</div>
				</div>
				<!-- 图片轮播 -->
				<swiper-slide
					v-if="(fileList.post_type == 1 || fileList.type == 1 ) && fileList.pics && fileList.pics.length > 0"
					v-for="(img_item, img_index) in fileList.pics"
					:key="'img-' + img_index"
					:class="img_item.video ? 'slideLiveBox' : ''"
					:style="fileList.pics.length > 1 && img_item.background ? img_item.background : ''"
				>
				
					<div class="slide_item" :class="get_item_Live(fileList.pics, img_item) ? 'slide_item_Live' : ''">
						<div v-if="img_item.video && checkBrowser()" class="LiveBtn" :class="!img_item.LivePlayState ? 'pointer' : 'no-drop noBtn'" @click.stop="LivePlay(img_item)">{{ $t('SwiperArr.Live') }}</div>
						<img v-if="!img_item.LivePlayState" :src="img_item.url" alt="post img" class="media-image"/>
						
						<video v-else src="img_item.video" :ref="liveVideo_post_id" autoplay muted playsinline class="Live-video" @ended="stopLivePlay(img_item)" >
							<source :src="img_item.video" type="video/mp4;">
							<!-- <source src="https://s3-us-tozo-test-wr.tozostore.com/Admin/app30/video/202501070712262626_1736233946qBnvkNdkM6VRX61g.mp4" type="video/mp4"> -->
						</video>
					</div>
				</swiper-slide>

				<!-- 视频轮播 -->
				<swiper-slide
					v-if="(fileList.post_type == 2 || fileList.type == 2 ) && fileList.videos && fileList.videos.length > 0"
					v-for="(video_item, video_index) in fileList.videos"
					:key="'video-' + video_index"
				>
					<div class="slide_item">
						<video :src="video_item" controls class="media-video" :poster="fileList.video_cover">
							<source :src="video_item" type="video/mp4">
						</video>
					</div>
				</swiper-slide>
				<!-- Pagination -->
				<!-- <div class="swiper-pagination"></div> -->
				<div v-show="fileList && fileList.SlideTotal > 1" class="swiper-pagination" @click.stop></div>
			</swiper>
		</div>
		
		
		<!-- 点击查看放大 -->
		<el-dialog :visible.sync="dialogVisible" width="100%" top="0" @click.stop>
			<img :src="dialogUrl" alt="" class="dialog_img">
			<div class="dialog-controls" v-if="fileList.pics.length > 1">
				<button type="button" @click.stop="prevImage" :disabled="currentImageIndex === 0"><i class="el-icon-arrow-left"></i></button>
				<button type="button" @click.stop="nextImage" :disabled="currentImageIndex === fileList.pics.length - 1"><i class="el-icon-arrow-right"></i></button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'

export default {
	name: 'handle-preview-swiper',
	components: { Swiper, SwiperSlide },
	props: {
		fileList: {
			type: Object,
		   default: () => ({
		      SlideTotal: 0,
		      pics: [
					{LivePlayState: false}
				],
		      videos: [],
		      currentSlideIndex: 1
		   })
		},
		// PreviewList: {
		// 	type: Array,
		// 	default() {
		// 		return [{}];
		// 	},
		// },
		currentUrl: {
			type: [Object, String],
			default() {
				return '';
			},
		},
		itemtype: {
			type: String,
			default: ""
		},
  },
  
  // 监听
  watch: {
  	"$route": {
  		handler: function (newValue, oldValue) {
  			this.closurePreview()
  		},
  		deep: true
  	},
  	"currentUrl": {
  		handler: function (newValue, oldValue) {
  			// this.get_currentUrl()
  		},
  		deep: true
  	},
  },
  
	computed: {
		swiper() {
			return this.$refs[`handlePreviewSwiper`].$swiper
		},
		liveVideo() {
			return this.$refs[`liveVideoHandlePreviewSwiper`]
		}
	},
	
  data() {
		let currentImageIndex = 0;
		const itemtype = this.itemtype;
		if (itemtype === "swiperSlideImg") {
		   currentImageIndex = this.fileList.pics.findIndex(
		      item => item.url.toLowerCase() === this.currentUrl.url.toLowerCase()
		   );
		}else if(itemtype === "swiperSlideVideo") {
		   currentImageIndex = this.fileList.videos.findIndex(
		      item => item.toLowerCase() === this.currentUrl.toLowerCase()
		   );
		}else if(itemtype === "UploadImg"){
			currentImageIndex = this.fileList.pics.findIndex(
			   item => item.url.toLowerCase() === this.currentUrl.toLowerCase()
			);
		}
		return {
        swiper_post_id: `handlePreviewSwiper`,
        liveVideo_post_id: `liveVideoHandlePreviewSwiper`,
        swiperOption: {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: this.fileList && this.fileList.SlideTotal > 1,
            touchMoveStopPropagation: true,
            autoplay: this.fileList && this.fileList.SlideTotal > 1? {
               delay: 5000,
               disableOnInteraction: false
            } : false,
            effect: 'fade',
            preventClicks: true,
            fadeEffect: { crossFade: true },
            pagination: {
               el: '.swiper-pagination',
               type: 'bullets',
               clickable: true
            },
            navigation: {
               nextEl: '.swiper-button-next',
               prevEl: '.swiper-button-prev'
            },
            rtl: true,
				on: {
				  click:function(clickedIndex){},
				},
				realIndex: 0,
				indexOfPlayingVideo: NaN,
				pauseVideoCb: function() {},
				// 设置初始显示的幻灯片索引为 0
				initialSlide: currentImageIndex
			},
			execute: false,
			dialogVisible: false,
			dialogUrl: "",
			currentImageIndex: currentImageIndex, // 当前显示的图片索引
		};
  },
  // closurePreview
  
	// 路由进入可操作数据
	activated() {
		this.set_bg_color()
		this.$nextTick(() => {
			this.change()
		});
		this.set_z_index('open')
	},

	created() {
		
	},
	
	mounted() {
		this.set_z_index('open'),
		console.log(this.fileList)
  		// this.get_currentUrl()
		this.set_bg_color()
		// 然后获取Swiper实例相关操作
		this.$nextTick(() => {
			this.change()
			// 获取 Swiper 实例并切换到指定幻灯片
			 // const swiperInstance = this.swiper;
			 // if (swiperInstance) {
				//  let index = this.get_currentUrl()
				//  console.log(index)
				// swiperInstance.slideTo(index+1);
			 // }
		});
	},

	methods: {
		set_z_index(type){
			let ContentLayout = document.getElementById("ContentLayout")
			if(ContentLayout){
				ContentLayout.style.zIndex = type == 'open' ? 999 : 2;
			}
		},
		// get_currentUrl(){
		// 	let itemtype = this.itemtype
		// 	let currentImageIndex = 0
		// 	if(itemtype === "swiperSlideImg"){
		// 		currentImageIndex = this.fileList.pics.findIndex(item => item.url.toLowerCase() === this.currentUrl.url.toLowerCase());
		// 	}else if(itemtype === "swiperSlideVideo"){
		// 		currentImageIndex = this.fileList.videos.findIndex(item => item.toLowerCase() === this.currentUrl.toLowerCase());
		// 	}
			
		// 	this.$set(this.swiperOption, 'initialSlide', currentImageIndex);
		// 	this.currentImageIndex = currentImageIndex
		// 	return currentImageIndex
		// },
		
		get_type_name(){
			let name = ''
			if (this.itemtype === "swiperSlideImg" || this.itemtype === "UploadImg") {
				if(this.fileList.pics.length > 1){
					name = true
				}else if(this.fileList.pics.length == 1){
					// if(this.fileList.pics[0].img_item.video){ //实况图
					// 	name = true
					// }else{
					// 	name = false
					// }
				}else{
					name = false
				}
			} else if (this.itemtype === "swiperSlideVideo" || this.itemtype === "UploadVideo") {
			   name = false
			}
			return name
		},
		
		get_item_Live(pics, item){
			if(pics.length == 1 && item.video){
				return true
			}else{
				return false
			}
		},
		
		closurePreview(){
			this.$emit('closurePreview')
			this.set_z_index()
		},
		
		checkBrowser() {
			const userAgent = navigator.userAgent.toLowerCase();
			const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);
		   if (isSafari) {
		      console.log('当前使用的是苹果浏览器（Safari）');
		      return true
		   } else {
		      console.log('当前使用的不是苹果浏览器（Safari）');
		      return false
		   }
		},
		
		set_height(){
			// this.swiper
			let swiper = document.getElementById(`handlePreviewSwiper`)
			
			if (swiper) {
				// 获取 swiper 容器的高度
				const swiperHeight = swiper.offsetHeight;
				// 获取所有的 swiper-slide 元素
				const swiperSlides = swiper.querySelectorAll('.swiper-slide');
				// 遍历所有的 swiper-slide 元素并设置高度
				swiperSlides.forEach((slide) => {
					slide.style.height = `${swiperHeight}px`;
				});
			}
		},
		
		async set_bg_color() {
			if(this.execute) { return }
			this.execute = true
		    console.log(this.fileList.pics);
		    if (!this.fileList.pics) {
		        this.complete = true;
		        return;
		    }
			 let that = this
		    // 创建一个数组来存储每个图片加载的 Promise
		    const promises = this.fileList.pics.map((image, index) => {
		        return new Promise((resolve, reject) => {
		            const img = new Image();
		            img.crossOrigin = 'anonymous';
		            img.src = image.url;
		            img.onload = () => {
		                try {
		                    const canvas = document.createElement('canvas');
		                    const ctx = canvas.getContext('2d');
		                    canvas.width = img.width;
		                    canvas.height = img.height;
		                    ctx.drawImage(img, 0, 0);
		                    const imageData = ctx.getImageData(0, 0, img.width, img.height);
		                    const data = imageData.data;
		                    let topColor = `rgba(${data[0]}, ${data[1]}, ${data[2]}, 0.5)`;
		                    let bottomColor = `rgba(${data[(img.height - 1) * img.width * 4]}, ${data[(img.height - 1) * img.width * 4 + 1]}, ${data[(img.height - 1) * img.width * 4 + 2]}, 0.5)`;
		                    // 这里简单取左上角颜色作为背景蒙层颜色，你可以根据需求调整
		                    image.bgColor = topColor;
		                    image.bottomColor = bottomColor;
		                    image.background = `background: linear-gradient(to bottom, ${topColor}, ${bottomColor});`;
								  // if(image.video){
										// that.get_live_url(image).then(url => {
										//    image.video_new = url;
										//    console.log(image.video_new); // 这里才能输出正确的 `blob URL`
										// });
								  // }
		                    resolve(image);
		                } catch (error) {
		                    console.error(error);
		                    reject(error);
		                }
		            };
		            img.onerror = () => {
		                const error = new Error('图片加载失败');
		                console.error(error);
		                reject(error);
		            };
		        });
		    });
		    try {
		        // 等待所有图片加载完成
		        this.fileList.pics = await Promise.all(promises);
		        this.complete = true;
				  if(this.fileList.pics && this.fileList.pics.length > 0){
						this.set_height()
				  }
		        console.log(this.fileList.pics);
		    } catch (error) {
		        console.error('图片颜色提取出错:', error);
		    }
		},
		
		async get_live_url(image) {
		   const response = await fetch(image.video);
		   const blob = await response.blob();
			console.log(blob)
		   let video_new = URL.createObjectURL(blob);
			return video_new ? video_new : ''
		},
		
		handleClickSlide(clickedIndex){
			this.$nextTick(() => {
				var swiper = this.swiper;
				this.realIndex = swiper.activeIndex = clickedIndex
			});
		},
		
		change() {
			this.realIndex = this.swiper.realIndex
			this.$set(this.fileList, 'currentSlideIndex', this.realIndex+1); //更新序号
			if (this.swiper.realIndex !== this.indexOfPlayingVideo) {
			// this.pauseVideoCb()
			}
		},
		
		// 播放
		handlePlay(pauseVideoCb, slideIndex) {
			this.pauseVideoCb = pauseVideoCb
			this.indexOfPlayingVideo = slideIndex
		},
		
		//播放Live视频
		LivePlay(img_item) {
			if(img_item.LivePlayState){ return }
			this.swiper.autoplay.stop();
			this.$set(img_item, 'LivePlayState', true);
		   const videoElement = this.liveVideo;
			console.log(videoElement)
		   if (videoElement) {
				this.$set(img_item, 'LivePlayState', false);
				this.$set(videoElement, 'muted', true); // 静音
				this.$set(videoElement, 'controls', true); // 隐藏控件
		      videoElement.play();  // 播放视频
				
		      // videoElement.muted = true;  // 静音
		      // videoElement.controls = false;  // 隐藏控件
		      // videoElement.play();  // 播放视频
		   }
		},
		
		//Live视频播放完显示回图片
		stopLivePlay(img_item) {
			this.$set(img_item, 'LivePlayState', false);
			this.swiper.autoplay.start();
		   const videoElement = this.liveVideo;
		   if (videoElement) {
				this.$set(img_item, 'LivePlayState', false);
				this.$set(videoElement, 'currentTime', 0);
		      videoElement.pause();  // 播放视频
			
				// this.$set(img_item, 'LivePlayState', false);
				// this.$nextTick(() => {
				//    const videoElement = this.liveVideo;
				//    if (videoElement) {
				// 		videoElement.pause();  // 停止播放
				//       videoElement.currentTime = 0;  // 重置到视频开头
				//    }
				// });
		   }
		},
	  
		//鼠标移入暂停轮播
		stopAutoplay() {
		   // console.log('Stopping autoplay for:', this.swiper);
			if (this.swiper) {
				// console.log('Stopping autoplay for:', this.swiper);
				this.swiper.autoplay.stop();
			} else {
				console.warn('No swiper available to stop.');
			}
		},
		
		//鼠标移出开始轮播
		startAutoplay() {
		   // console.log('Stopping autoplay for:', this.swiper);
			if (this.swiper) {
				// console.log('Starting autoplay for:', this.swiper);
				this.swiper.autoplay.start();
			} else {
				console.warn('No swiperInstance available to start.');
			}
		},
		
		// 点击查看大图
		handlePreview(url) {
			let currentRouteName = this.$route.name;
			if(currentRouteName != 'PostDetails'){ return }
			this.currentImageIndex = this.fileList.pics.findIndex(item => item.url.toLowerCase() === url.toLowerCase());
			this.dialogUrl = url;
			this.dialogVisible = true;
		},
		
		nextImage() {
			if (this.currentImageIndex < this.fileList.pics.length - 1) {
				this.currentImageIndex++;
				this.dialogUrl = this.fileList.pics[this.currentImageIndex].url;
			}
		},
		
		prevImage() {
			if (this.currentImageIndex > 0) {
				this.currentImageIndex--;
				this.dialogUrl = this.fileList.pics[this.currentImageIndex].url;
			}
		}

	},
};
</script>

<style lang="less" scoped>
	 @import '~swiper/css/swiper.css';
	.PreviewSwiper_picture_and_video_box {
	  z-index: 9999;
	  position: fixed;
	  left: 0;
	  top: 0;
	  width: 100%;
	  height: calc(100% - 0px);
	  box-sizing: border-box;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  padding: 20px;
	  background-color: rgba(0, 0, 0, 0.8);
	}
	.closurePreview{
		position: fixed;
		z-index: 9999;
		font-size: 32px;
		right: 10px;
		top: 10px;
		width: 40px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		color: #ffffff;
	}

	.media-carousel {
	  width: 100%;
	  margin: 0 auto;
	}

	.media-image {
	  width: 100%;
	  height: auto;
	  object-fit: cover;
	  border-radius: 5px;
	}

	.Live-video{
	  width: 100%;
	  height: 100%;
	  border-radius: 5px;
	}
	.media-video {
	  width: 100%;
	  height: auto;
	  border-radius: 5px;
	}
	::v-deep .swiper-wrapper {
	   position: relative;
	   width: 100%;
	   height: 100%;
	   z-index: 1;
	   display: flex;
	   transition-property: transform;
	   box-sizing: content-box;
	   align-items: center;
	}
	.swiper_picture_box{
		::v-deep .swiper-container {
			border: 1px solid #999999;
		}
	}
	.swiper_video_box{
		.slide_item{
			width: 100%;
			height: 100%;
			display: flex;
			position: relative;
			justify-content: center;
			align-items: center;
		}
		.slide_item_Live.slide_item{
			width: auto;
		}
		::v-deep .swiper-wrapper {
		   margin: auto;
		}
		.media-video{
			width: auto;
			height: auto;
		}
	}
	::v-deep .swiper-container {
		width: 100%;
		height: 100%;
		display: flex;
		max-height: calc(100vh - 80px);
		max-width: calc(100vw - 40px);
		border-radius: 5px;
	}
	::v-deep .image-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		position: relative;
	}

	.swiper {
	  width: 100%;
	  height: auto;
	}
	.PreviewSwiper_picture_and_video_box{
		.slide_item{
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  height: 100%;
		}
		::v-deep .swiper-slide {
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  height: 100%;
		  border-radius: 5px;
		  overflow: hidden;
		  img{
				border-radius: 0px;
				max-height: 100%;
				height: auto;
				width: auto !important;
				// height: auto !important;
				// width: auto !important;
				// width: 100%;
				// max-height: calc(100% - 80px);
				// max-width: calc(100% - 40px);
				object-fit: cover;
		  }
		}
	}

	::v-deep .swiper-pagination-bullet {
		width: 20px;
		height: 8px;
		display: inline-block;
		border-radius: 4px;
		background: #000;
		border: 1px #fff solid;
		opacity: 0.5;
		margin: 0px 4px;
	}
	.swiper-pagination {
	  position: absolute;
	  bottom: 10px;  /* Adjust to position the pagination at the bottom */
	  left: 50%;
	  width: 100%;
	  transform: translateX(-50%);
	  z-index: 10;
	}
	/deep/ .swiper-pagination-bullet-active {
	    opacity: 1;
		background: #06f;
		// background: #2094FA;
	}
	.media-carousel .swiper-slide{
		max-height: 100%;
	}
	.swiperBox{
		position: relative;
	}
	.quantityBox{
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 999;
		padding: 5px 10px;
		line-height: 1;
		background-color: rgba(0, 0, 0, 0.5);
		border: 1px #f5f5f5 solid;
		color: #ffffff;
		font-size: 12px;
		border-radius: 4px;
		display: flex;
	}
	.slideLiveBox{
		position: relative;
		video::-webkit-media-controls {
		    display: none!important;
		}
		video::-webkit-media-controls-enclosure {
		    display: none!important;
		}
		video::-webkit-media-controls-panel {
		    display: none!important;
		}
		
		video::-moz-media-controls {
		    display: none!important;
		}
		video::-moz-media-controls-enclosure {
		    display: none!important;
		}
		video::-moz-media-controls-panel {
		    display: none!important;
		}
		
		video::-ms-media-controls {
		    display: none!important;
		}
		video::-ms-media-controls-enclosure {
		    display: none!important;
		}
		video::-ms-media-controls-panel {
		    display: none!important;
		}
		
		video::media-controls {
		    display: none!important;
		}
		video::media-controls-enclosure {
		    display: none!important;
		}
		video::media-controls-panel {
		    display: none!important;
		}
	}
	.LiveBtn{
		position: absolute;
		top: 10px;
		left: 10px;
		z-index: 999;
		padding: 5px 10px;
		line-height: 1;
		background-color: rgba(0, 0, 0, 0.5);
		border: 1px #f5f5f5 solid;
		color: #ffffff;
		font-size: 14px;
		border-radius: 4px;
	}
	.LiveBtn.noBtn{
		background-color: #666666;
		color: #999999;
		border: 1px #666666 solid;
	}
	.pointer{
		cursor: pointer;
	}
	.no-drop{
		cursor: no-drop;
	}
	
	.dialog_img{
	  max-width: 100%;
	  height: auto;
	}
  .dialog-controls {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .dialog-controls button {
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
	 width: 40px;
	 height: 40px;
	 border-radius: 40px;
	 display: flex;
	 justify-content: center;
	 align-items: center;
    cursor: pointer;
	 font-size: 25px;
  }
  .dialog-controls button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
	@media only screen and (min-width: 1023px) {
		.PreviewSwiper_picture_and_video_box {
		  z-index: 9999;
		  position: fixed;
		  left: 0;
		  top: 0;
		  width: 100%;
		  height: calc(100% - 0px);
		  box-sizing: border-box;
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  padding: 20px;
		  background-color: rgba(0, 0, 0, 0.8);
		}
		.closurePreview{
			position: fixed;
			z-index: 9999;
			font-size: 32px;
			right: 10px;
			top: 10px;
			width: 40px;
			height: 40px;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			color: #ffffff;
		}
		::v-deep .image-wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
			position: relative;
		}
		
		.swiper {
		  width: 100%;
		  height: auto;
		}
		
		.PreviewSwiper_picture_and_video_box{
			::v-deep .swiper-container {
				width: 100%;
				height: 100%;
				display: flex;
				min-height: calc(100vh - 190px);
				max-height: calc(100vh - 190px);
				max-width: calc(100vw - 40px);
			}
			::v-deep .swiper-slide {
			  display: flex;
			  justify-content: center;
			  align-items: center;
			  height: 100%;
			  border-radius: 5px;
			  overflow: hidden;
			  img{
					border-radius: 0px;
					max-height: 100%;
					height: auto;
					width: auto;
					// height: auto !important;
					// width: auto !important;
					// width: 100%;
					// max-height: calc(100% - 80px);
					// max-width: calc(100% - 40px);
					object-fit: cover;
			  }
			}
		}
		.swiper_video_box{
			.media-video{
				width: auto;
				height: auto;
				max-height: calc(100vh - 190px);
			}
		}
	}
	@media only screen and (max-width: 1023px) {
		.PreviewSwiper_picture_and_video_box {
		  z-index: 9999;
		  position: fixed;
		  left: 0;
		  top: 0;
		  width: 100%;
		  height: calc(100% - 0px);
		  box-sizing: border-box;
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  padding: 10px;
		  background-color: rgba(0, 0, 0, 0.8);
		}
		.closurePreview{
			position: fixed;
			z-index: 9999;
			font-size: 28px;
			right: 10px;
			top: 10px;
			width: 28px;
			height: 28px;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			color: #ffffff;
		}
		::v-deep .image-wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
			position: relative;
		}
		
		.swiper {
		  width: 100%;
		  height: auto;
		}
		
		.PreviewSwiper_picture_and_video_box{
			::v-deep .swiper-container {
				width: 100%;
				height: 100%;
				display: flex;
				min-height: calc(100vh - 140px);
				max-height: calc(100vh - 140px);
				max-width: calc(100vw - 20px);
			}
			::v-deep .swiper-slide {
			  display: flex;
			  justify-content: center;
			  align-items: center;
			  height: 100%;
			  border-radius: 5px;
			  overflow: hidden;
			  img{
					border-radius: 0px;
					max-width: 100%;
					height: auto;
					width: auto;
					// height: auto !important;
					// width: auto !important;
					// width: 100%;
					// max-height: calc(100% - 80px);
					// max-width: calc(100% - 40px);
					object-fit: cover;
			  }
			}
		}
		.swiper_video_box{
			.media-video{
				width: auto;
				height: auto;
				max-width: 100%;
			}
		}
	}
</style>
